export const formMaterialManagementNaming = {
  NEW_MATERIAL_MANAGEMENT_FORM: 'new-material-management-form',
};
